import { render, staticRenderFns } from "./publicbenactdetail.vue?vue&type=template&id=2aff5162&scoped=true&"
import script from "./publicbenactdetail.vue?vue&type=script&lang=js&"
export * from "./publicbenactdetail.vue?vue&type=script&lang=js&"
import style0 from "./publicbenactdetail.vue?vue&type=style&index=0&id=2aff5162&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff5162",
  null
  
)

export default component.exports